import type { CommandData } from '../types'

export function open() {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'open',
  }
  window.postMessage(message)
}
